module.exports = __webpack_public_path__ + "img/6.92ca9f2b.svg";